<template>
  <div>
    <div class="doctor clearfix" :class="type === 2 ? 'doctor1' : 'doctor2'">
      <router-link :to="'/doctor/' + id + '?hideNav=1'">
      <div class="head border-blue">
        <img :src="doctor.image" alt="">
      </div>
      </router-link>
      <div class="info">
        <template v-if="type === 2">
          <h2>{{ doctor.name }} <span class="desc2 line1">{{ doctor.good_at }}</span></h2>
          <p class="desc line1">{{ doctor.level_title }}</p>
          <ul>
            <li>三甲医院</li>
            <li>急速回复</li>
            <li>专业有效</li>
          </ul>
        </template>
        <template v-else>
          <div>
          <h2 class="line1">{{ doctor.name }}</h2>
          <ul>
            <li>三甲医院</li>
            <li>急速回复</li>
            <li>专业有效</li>
          </ul>
          </div>
          <div class="desc">
            <span class="line1">{{ doctor.good_at }}</span>
            <span class="line1">{{ doctor.level_title }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Doctor',
    data() {
      return {
        msg: 'Hello Vue!'
      };
    },
    props: {
      doctor: {

      },
      type: {
        type: Number,
        default: 1
      },
      id: null
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    },
    components: {
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../assets/base.less";

  .doctor {
    width: 100%;
    padding: 25px 0 28px 32px;

    .info {
      float: left;
      margin-left: 47px;
      margin-top: 20px;

      h2 {
        margin-bottom: 22px;
        color: @color-black;
        font-size: 38px;
        line-height: 38px;

        span {
          padding-left: 15px;
          color: @color-gray-light;
          font-size: 28px;
          font-weight: normal;
        }
      }

      p {
        margin-bottom: 20px;
        color: @color-gray-dark;
        font-size: 32px;
        line-height: 32px;
      }

      ul > li {
        float: left;
        margin-right: 10px;
        padding: 5px 8px;
        border: 1px solid @color-blue-light; /*px*/
        border-radius: 8px;
        color: @color-blue-light;
        font-size: 24px;
      }
    }
  }

  .doctor1 {
    margin-bottom: 18px;
    border-bottom: 16px solid rgba(245, 245, 245, 1);
    .head {
      position: relative;
      float: left;
      width: 192px;
      height: 192px;
      border-radius: 100%;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display: block;
        width: 166px;
        height: 166px;
        border-radius: 100%;
      }
    }
    .desc {
      width: 400px;
    }
    .desc2 {
      width: 240px;
    }
  }

  .doctor2 {
    padding: 22px 0 22px 25px;
    a {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      border-radius: 100%;
      border: 1px solid @color-blue-light; /*px*/
      overflow: hidden;

      .head {
        border-radius: 0;
        border: 0;
      }

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display: block;
        width: 106px;
        height: 106px;
        border-radius: 100%;
      }
    }

    .info {
      float:left;
      padding-top: 4px;
      margin-top: 0;
      margin-left: 26px;

      h2 {
        width: 144px;
        display: inline-block;
        font-size: 36px;
        height: 36px;
        line-height: 36px;
        margin-bottom: 0;
        margin-right: 13px;
        margin-left: 0;
        position: relative;
        top: 3px;
      }

      ul {
        display: inline-block;
        position: relative;
        top: 10px;

        li {
          font-size: 24px;
          padding: 5px 8px;
          margin-right: 8px;
        }
      }

      .desc {
        color: rgb(136, 136, 136);
        margin-top: 23px;
        font-size: 26px;
        line-height: 26px;
        span {
          margin-right: 26px;
          width: 364px;
          &:last-child{
            width: 130px;
            margin-right: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Doctor.vue?dff145a0